module.exports = __webpack_public_path__ + "assets/img/edd80e7b65e488b2fc125212ffe05f44.png";